export const formatPrice = (price, currency) => {
  return `${Intl.NumberFormat("en-SG", {
    style: "currency",
    currency: currency || "SGD",
  }).format(price)}`
}
